import { equal, greaterThan, length, notEqual } from "./javascript";
import {
  firstLetterToUppercase,
  emailValidation,
  letterSpacing,
  atLeastOneNumber,
  atLeastOneCapitalCase,
  atLeastOneLowerCase,
  domainPattern,
  atLeastOneSpecialCharacter,
} from "./regex";

export const allValidations = (
  name,
  value,
  state,
  ignore = [],
  isRequired = true
) => {
  const formErrors = { ...state.formErrors };
  if (ignore.includes(name)) {
    if (formErrors[name]) {
      formErrors[name] = "";
    }
    return formErrors;
  }
  switch (name) {
    case "file":
      if (isRequired && !value) {
        formErrors[name] = "Zip File is required!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "mainFile":
      if (!value) {
        formErrors[name] = "Main File Name is required!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "handler":
      if (!value) {
        formErrors[name] = "Handler Name is required!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "org":
      if (!value) {
        formErrors[name] = "Organization Id is required!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "memory":
      if (!value) {
        formErrors[name] = "Memory is required!";
      } else if (value < 128) {
        formErrors[name] = "Memory must be >= 128!";
      } else if (value > 3008) {
        formErrors[name] = "Memory must be <= 3008!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "runTime":
      if (!value) {
        formErrors[name] = "Runtime is required!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "region":
      if (!value) {
        formErrors[name] = "Region is required!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "timeout":
      if (!value) {
        formErrors[name] = "Timeout is required!";
      }
      if (value < 3) {
        formErrors[name] = "Timeout must be >= 3!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "interval":
      if (!value) {
        formErrors[name] = "Interval is required!";
      }
      if (value < 60) {
        formErrors[name] = "Interval cannot be less than 60 seconds!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "method":
      if (!value) {
        formErrors[name] = "Method is required!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "route":
      const routePattern = /^\/.*[^\/]$/;
      if (!value) {
        formErrors[name] = "Route is required!";
      } else if (!routePattern.test(value)) {
        formErrors[name] = "Route must start with '/' and not end with '/'";
      } else {
        formErrors[name] = "";
      }
      break;
    case "email":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (!emailValidation(value)) {
        formErrors[name] = `Please enter valid email!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "phoneNumber":
      let phone = value.replace(/\s/g, "");
      if (equal(length(value))) {
        formErrors[name] = `${letterSpacing(name)} is required!`;
      } else if (phone.length <= 10) {
        formErrors[name] = `${firstLetterToUppercase(name)} is not valid.`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "fullName":
    case "name":
    case "organization_name":
    case "organizationName":
    case "first_name":
    case "last_name":
    case "oldPassword":
      if (value && value.length === 0) {
        formErrors[name] = `${firstLetterToUppercase(
          letterSpacing(name)
        )} is required!`;
      } else if (greaterThan(length(value), 70)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} exceeds character limit. Maximum allowed: 70 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "status_codes":
      if (value.length === 0) {
        formErrors[name] = `${firstLetterToUppercase(
          letterSpacing(name)
        )} is required!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "source":
    case "destination":
    case "request_path":
    case "header_name":
    case "header_value":
    case "path":
      if (value.length === 0) {
        formErrors[name] = `${firstLetterToUppercase(
          letterSpacing(name)
        )} is required!`;
      } else if (greaterThan(length(value), 70)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} exceeds character limit. Maximum allowed: 70 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "loginPassword":
      if (value.length === 0) {
        formErrors[name] = `Password is required!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "password":
      if (value.length === 0) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (value.length < 12) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} must be at least 12 characters!`;
      } else if (!atLeastOneLowerCase.test(value)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} must have one lower case letter!`;
      } else if (!atLeastOneCapitalCase.test(value)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} must have one upper case letter!`;
      } else if (!atLeastOneNumber.test(value)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} must have one number!`;
      } else if (!atLeastOneSpecialCharacter.test(value)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} must have one special character!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "confirmPassword":
    case "newConfirmPassword":
      if (equal(length(value))) {
        formErrors[name] = `Confirm Password is required!`;
      } else if (notEqual(state?.password, value)) {
        formErrors[name] = `${
          name === "newConfirmPassword" ? "New " : ""
        } Password and Confirm Password is not match!`;
      } else if (equal(state?.password, value)) {
        formErrors[name] = "";
      }
      break;

    case "zip_code":
      if (value.length === 0) {
        formErrors[name] = `${letterSpacing(name)} is required.`;
      } else if (value.length > 70) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} exceeds character limit. Maximum allowed: 70 characters.`;
      } else {
        // ZIP code is valid
        formErrors[name] = "";
      }
      break;

    case "title":
    case "firstName":
    case "lastName":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "age":
    case "dob":
      if (value === null || value === 0 || value === "") {
        formErrors[name] = `${letterSpacing(name)} is required!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "domain":
      if (!domainPattern(value)) {
        formErrors[name] = `Please enter a valid domain`;
      } else if (value.length > 50) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} exceeds character limit. Maximum allowed: 50 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "targetCPUValue":
    case "targetRamValue":
    case "repository_name":
    case "branch":
    case "slug":
    case "base_dir":
    case "build_dir":
    case "build_cmd":
      if (state.slug !== "container" && !value) {
        formErrors[name] = `${firstLetterToUppercase(
          name.split("_").join(" ")
        )} is required`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "region":
    case "start_cmd":
    case "docker_build_context_dir":
    case "docker_file_path":
    case "docker_command":
    case "project_id":
      if (!value) {
        formErrors[name] = `${firstLetterToUppercase(
          name === "project_id"
            ? "Project"
            : name.includes("_")
            ? name.split("_").join(" ")
            : name
        )} is required`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "minRAMValue":
    case "maxRAMValue":
    case "minCPUValue":
    case "maxCPUValue":
    case "minReplicas":
    case "maxReplicas":
      if (name === "maxRAMValue" && value < state.minRAMValue) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} should be greater than min value`;
      } else if (name === "maxCPUValue" && value < state.minCPUValue) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} should be greater than min value`;
      } else if (name === "maxReplicas" && value < state.minReplicas) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} should be greater than min value`;
      } else {
        formErrors[name] = "";
      }
      break;
    default:
      break;
  }
  return formErrors;
};
